// Thumbnail click → update main image
document.addEventListener('click', e => {
if(e.target.closest('.pv-thumb')){
const btn = e.target.closest('.pv-thumb');
const mainImg = document.querySelector('.pv-gallery-main img');
if(mainImg && btn.dataset.img){
mainImg.src = btn.dataset.img;
}
}
});


// AJAX add to cart
const forms = document.querySelectorAll('form[action="/cart/add"]');
forms.forEach(form => {
form.addEventListener('submit', async e => {
e.preventDefault();
const fd = new FormData(form);
const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
if(res.ok){
await updateMiniCart();
openMiniCart();
}else{
const err = await res.json();
alert(err.description || 'Error adding to cart');
}
});
});


// Update mini-cart drawer
async function updateMiniCart(){
const resCart = await fetch('/cart.js');
const cartData = await resCart.json();
const cartContainer = document.querySelector('.pv-mini-cart__items');
const subtotalEl = document.querySelector('.pv-mini-cart__subtotal');
const progressEl = document.querySelector('.pv-mini-cart__progress-bar-inner');
const count = document.querySelector('.cart-count');


if(count) count.textContent = cartData.item_count;
if(cartContainer){
cartContainer.innerHTML = '';
cartData.items.forEach(item => {
cartContainer.innerHTML += `
<div class="pv-mini-cart__item">
<img src="${item.image}" alt="${item.title}"/>
<div>
<h4>${item.title}</h4>
<p>${item.quantity} × ${Shopify.formatMoney(item.price)}</p>
</div>
</div>`;
});
}


if(subtotalEl){
subtotalEl.textContent = Shopify.formatMoney(cartData.total_price);
}


// Free shipping progress bar
const freeShipThreshold = 7500; // adjust: 7500 = $75.00 if cents
if(progressEl){
const progress = Math.min(cartData.total_price / freeShipThreshold * 100, 100);
progressEl.style.width = progress + '%';
}
}


// Mini-cart drawer toggle
function openMiniCart(){
document.querySelector('.pv-mini-cart').classList.add('open');
}
function closeMiniCart(){
document.querySelector('.pv-mini-cart').classList.remove('open');
}


document.addEventListener('click', e => {
if(e.target.matches('.pv-mini-cart__close')) closeMiniCart();
if(e.target.matches('.pv-mini-cart__overlay')) closeMiniCart();
});


// Journey Set bundle: color-name to hex mapping for circular swatches (2026-09)
(function () {
  var COLOR_MAP = {
      'chocolate': '#74443b',
          'dark chocolate': '#74443b',
              'ivory': '#d5cfc7',
                  'nightfall': '#000000'
                    };

                      function applySwatchColors() {
                          document.querySelectorAll('.block-swatch').forEach(function (el) {
                                if (el.dataset.swatchApplied) return;
                                      var label = (el.textContent || '').trim().toLowerCase();
                                            var hex = COLOR_MAP[label];
                                                  if (hex) {
                                                          el.style.setProperty('--swatch-background', hex);
                                                                  el.dataset.swatchApplied = 'true';
                                                                        }
                                                                            });
                                                                              }

                                                                                document.addEventListener('DOMContentLoaded', applySwatchColors);
                                                                                  applySwatchColors();

                                                                                    var swatchObserver = new MutationObserver(applySwatchColors);
                                                                                      swatchObserver.observe(document.body, { childList: true, subtree: true });
                                                                                      })();
                                                                                      